import siteVerificationStore from '@Modules/cms/stores/siteVerification';
import allocationStore from '@Modules/offer/stores/allocation';
import publisherStore from '@Modules/offer/stores/publisher';
import metaFieldStore from '@Modules/settings/stores/meta-field';

import BaseReportStore from './base-store'

export default new class SiteVerificationStore extends BaseReportStore {
  constructor() {
    super(true)
  }

  endpointReport = 'site-verification'

  publisher = this.attachEntity(publisherStore)
  allocation = this.attachEntity(allocationStore, { labelKey: 'description' })
  verification = this.attachEntity(siteVerificationStore)
  metaField = this.attachEntity(metaFieldStore, {
    labelKey: 'key',
    valueKey: 'key',
    labelFn: ({ value }) => value,
  });
}
